import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Setvalues } from '../../core/entities/setvalues.model'
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class SetvaluesService {
    readonly BASE: any = PETICIONES.setvalues;

    constructor(private http: HttpClient) { }

    /**
   * @description
   * Obtiene todos los setvalues
   */
  public findAll(): Observable<any> {
    return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
  }

  /**
   * @description
   * Obtiene un setvalues por su id
   */
  public findById(id: number): Observable<any> {
    let idsetvalues: string = (id !== undefined && id !== null ? id + "" : "");
    return this.http.get(this.BASE.findById + "/" + idsetvalues).pipe(delay(DELAY));
  }

  /**
   * @description
   * Guarda un setvalues en la base de datos
   */
  public postSetvalue(setvalues: Setvalues): Observable<any> {
    const json = JSON.stringify(setvalues);
    const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
    return this.http.post(this.BASE.postSetvalues, json, {headers: headers}).pipe(delay(DELAY));
  }

  /**
   * @description
   * Borra un setvalues en la base de datos
   */
  public deleteSetvalue(setvalues: Setvalues): Observable<any> {
    let idsetvalues: string = (setvalues.id !== undefined && setvalues.id !== null ? setvalues.id + "" : "");
    return this.http.get(this.BASE.deleteSetvalues + "/" + idsetvalues).pipe(delay(DELAY));
  }

}